var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 173.07 374.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-width:2.02px;stroke:url(#linear-gradient);}.cls-1,.cls-3{stroke-miterlimit:10;}.cls-2,.cls-3{fill:#3ac2d7;}.cls-3{stroke-width:2.23px;stroke:url(#linear-gradient-2);}.cls-4{fill:#b498c6;}.cls-5{fill:url(#New_Gradient_Swatch_15);}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.07,
    y1: 76.87,
    x2: 56.09,
    y2: 76.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b498c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 122.98,
    y1: 149.49,
    x2: 125.21,
    y2: 149.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_15",
    cx: 57.12,
    cy: 162.95,
    r: 70.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cae8e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac2d7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ADMINDASH"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.08,
    x2: 55.08,
    y2: 153.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.85,170.48c-7.54,11.38,2,23.5,13.19,21a12.83,12.83,0,0,0,9.64-9.65c2.49-11.22-9.62-20.73-21-13.18A6.31,6.31,0,0,0,44.85,170.48Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.1,
    x2: 124.1,
    y2: 298.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.59,316.77c-6.94,11.24,2.46,23,13.51,20.51a12.85,12.85,0,0,0,9.65-9.65c2.45-11.06-9.27-20.45-20.5-13.51A8.21,8.21,0,0,0,114.59,316.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.07,333V319.37a4,4,0,0,0-4-4h-6.21a4,4,0,0,1-3.74-2.5c-.15-.39-.32-.78-.49-1.17a4,4,0,0,1,.88-4.42l4.39-4.4a4,4,0,0,0,0-5.72l-9.63-9.64a4.06,4.06,0,0,0-5.73,0l-4.39,4.4a4,4,0,0,1-4.42.87l-1.18-.49a4,4,0,0,1-2.49-3.74v-6.21a4.05,4.05,0,0,0-4-4.05H118.33a4.05,4.05,0,0,0-4,4.05v6.21a4,4,0,0,1-2.49,3.74c-.39.16-.79.32-1.17.49a4,4,0,0,1-4.42-.87l-4.4-4.4a4,4,0,0,0-5.72,0l-9.64,9.64a4,4,0,0,0,0,5.72l4.4,4.4a4,4,0,0,1,.87,4.42c-.17.39-.34.78-.49,1.17a4,4,0,0,1-3.74,2.5H81.27a4,4,0,0,0-4,4V333a4,4,0,0,0,4,4.05h6.21a4,4,0,0,1,3.74,2.49c.15.4.32.79.49,1.18a4,4,0,0,1-.87,4.42l-4.4,4.39a4.06,4.06,0,0,0,0,5.73l9.64,9.63a4,4,0,0,0,5.72,0l4.4-4.39a4,4,0,0,1,4.42-.88c.38.17.78.34,1.17.49a4,4,0,0,1,2.49,3.74v6.21a4.05,4.05,0,0,0,4,4.05H132a4.05,4.05,0,0,0,4-4.05v-6.21a4,4,0,0,1,2.49-3.74c.39-.15.79-.32,1.18-.49a4,4,0,0,1,4.42.88l4.39,4.39a4.06,4.06,0,0,0,5.73,0l9.63-9.63a4.06,4.06,0,0,0,0-5.73l-4.39-4.39a4,4,0,0,1-.88-4.42c.17-.39.34-.78.49-1.18a4,4,0,0,1,3.74-2.49H169A4,4,0,0,0,173.07,333Zm-45.71,20.4a27.3,27.3,0,1,1,25-25A27.31,27.31,0,0,1,127.36,353.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.08,124.66a55.08,55.08,0,1,0,55.08,55.08A55.08,55.08,0,0,0,55.08,124.66Zm0,81.08a26,26,0,1,1,26-26A26,26,0,0,1,55.08,205.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.08,231.38a51.64,51.64,0,1,1,51.64-51.64A51.7,51.7,0,0,1,55.08,231.38Zm0-102.52A50.88,50.88,0,1,0,106,179.74,50.94,50.94,0,0,0,55.08,128.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicSide);
export default __webpack_public_path__ + "static/media/graphic_side.85e35f5bf0ecdfff23f280661d6fff04.svg";
export { ForwardRef as ReactComponent };